module.exports = __webpack_public_path__ + "price-spectrum.svg?abbc26a7c548e25d2418c3fa5f8a91aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/price-spectrum.svg
// module id = 310
// module chunks = 2